import Vue from 'vue';
import axios from 'axios';
import {hasPermission} from "../../utils/permissions";

// initial state
const state = {
 category:{},
  post: {},
  posts: [],
  product:{},
  totalPages: 0
}

// getters
const getters = {
  category:(state) => {
    return state.category;
  },
  product:(state) => {
    return state.product;
  },
  post: (state) => {
    return state.post;
  },
  posts: (state) => {
    return state.posts;
  },
  totalPages: (state) => {
    return state.totalPages;
  }
}

// mutations
const mutations = {
  SET_CATEGORY(state , category){
    state.category = category;
  },
  SET_PRODUCT(state , product){
    state.product = product;
  },
  SET_POST(state, post) {
    state.post = post;
  },

  SET_POSTS(state, posts) {
    state.posts = posts;
  },

  SET_ACTION(state, action) {
    state.action = action;
  },

  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },

  ADD_POST(state, post) {
    state.posts.push(JSON.parse(JSON.stringify(post)));
  },

  UPDATE_POSTS(state, post) {
    let postIndex = state.posts.findIndex((item) => {
      return item.id === post.id;
    });
    Vue.set(state.posts, postIndex, JSON.parse(JSON.stringify(post)));
  },

  DELETE_POSTS(state, post) {
    let postIndex = state.posts.findIndex((item) => {
      return item.id === post.id;
    });

    if (postIndex > -1) {
      state.posts.splice(postIndex, 1);
    }
  }
}

// actions
const actions = {

  getAllPosts({commit}, page) {
    if(hasPermission('all_posts_list')){
      const permission = {
        headers: {
          'X-Permission': 'all_posts_list'
        }
      };
      let product_id=localStorage.getItem('product');
      axios.get('/admin/posts?page=' + page +'&product_id=' + product_id,permission)
          .then((response) => {
            let res = response.data;
            commit('SET_POSTS', res.data);

            let totalPages = Math.ceil(res.total / res.per_page);
            commit('SET_TOTAL_PAGES', totalPages);
          });
    }
  },

  // =========================================================================

  getUnpublishedPosts({commit}, page) {
    if(hasPermission('unpublished_post_list')){
      const permission = {
        headers: {
          'X-Permission': 'unpublished_post_list'
        }
      };
      let product_id=localStorage.getItem('product');
      let pageNumber  = page ? page : 1;
      axios.get('/admin/posts/unpublished?page=' + pageNumber +'&product_id=' + product_id,permission)
          .then((response) => {
            let res = response.data;
            commit('SET_POSTS', res.data);

            let totalPages = Math.ceil(res.total / res.per_page);
            commit('SET_TOTAL_PAGES', totalPages);
          });
    }
  },

  // =========================================================================

  getPost({commit}, post) {
    if(hasPermission('new_post_list')){
      const permission = {
        headers: {
          'X-Permission': 'new_post_list'
        }
      };
      return axios.get(`/admin/posts/${post}?product_id=`+localStorage.getItem('product'),permission)
          .then((response) => {
            commit('SET_POST', response.data.post);
          });
    }
  },

  // =========================================================================

  getCategoryPosts({commit}, payload) {
    axios.get('/admin/categories/' + payload.category + '/posts?page=' + payload.page)
    .then((response) => {
       let res = response.data;
       commit('SET_POSTS', res.data);

       let totalPages = Math.ceil(res.total / res.per_page);
       commit('SET_TOTAL_PAGES', totalPages);
     });
  },

 

  // =========================================================================

  getTagPosts({commit}, payload) {
    axios.get('/admin/tags/' + payload.tag + '/posts?page=' + payload.page)
    .then((response) => {
       let res = response.data;
       commit('SET_POSTS', res.data);

       let totalPages = Math.ceil(res.total / res.per_page);
       commit('SET_TOTAL_PAGES', totalPages);
     });
  },

  // =========================================================================

  getUserPosts({commit}, payload) {
    axios.get('/admin/users/' + payload.user + '/posts?page=' + payload.page)
    .then((response) => {
       let res = response.data;
       commit('SET_POSTS', res.data);

       let totalPages = Math.ceil(res.total / res.per_page);
       commit('SET_TOTAL_PAGES', totalPages);
     });
  },
getProduct({commit}){
  
  return  axios.get(`/admin/get-post?product_id=${localStorage.getItem('product')}`)
  .then((response) => {
    let res = response.data;
    commit('SET_PRODUCT', res);
    return res;
  });
},
  // =========================================================================

  createPost({}, post) {
    let tagsNames = post.tags.map((tag) => {
      return tag.name;
    });

    let formData = new FormData();
    formData.append('slug', post.new_slug);
    formData.append('title', post.title);
    formData.append('body', post.body);
    formData.append('caption', post.caption);
    formData.append('category_id', post.category.id);
    formData.append('meta_title', post.meta_title ? post.meta_title : "");
    formData.append('meta_description', post.meta_description ? post.meta_description : "");
    formData.append('short_description', post.short_description ? post.short_description : "");
    formData.append('meta_keyword', post.meta_keyword ? post.meta_keyword : "");


    if(post.show_in_admin)
      formData.append('show_in_admin', 1);
    else
      formData.append('show_in_admin', 0);

    if(post.featured)
      formData.append('featured', 1);
    else
      formData.append('featured', 0);

    if(post.send_email)
      formData.append('send_email', 1);
    else
      formData.append('send_email', 0);

    if(post.remove_image)
      formData.append('remove_image', 1);
    else
      formData.append('remove_image', 0);


    for (var i = 0; i < tagsNames.length; i++) {
        formData.append('tags[]', tagsNames[i]);
    }
    if(hasPermission('new_post_list')){
      const permission = {
        headers: {
          'X-Permission': 'new_post_list'
        }
      };
      return axios.post(`/admin/posts?product_id=${localStorage.getItem('product')}`, formData,permission, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then((response) => {
            return response.data.post.slug;
          })
    }
  },

  // =========================================================================

  async updatePost ({}, post) {
    // let tagsNames = post.tags.map((tag) => {
    //   return tag.name;
    // });
    let formData = new FormData();
    formData.append('_method', 'PUT');
    formData.append('id', post.id);
    formData.append('slug', post.new_slug);
    formData.append('title', post.title);
    formData.append('body', post.body);
    formData.append('meta_title', post.meta_title ? post.meta_title : "");
    formData.append('meta_description', post.meta_description ? post.meta_description : "");
    formData.append('meta_keyword', post.meta_keyword ? post.meta_keyword : "");
    formData.append('short_description', post.short_description || "");
    if(post.show_in_admin)
      formData.append('show_in_admin', 1);
    else
      formData.append('show_in_admin', 0);

    if(post.featured)
      formData.append('featured', 1);
    else
      formData.append('featured', 0);

    if(post.send_email)
      formData.append('send_email', 1);
    else
      formData.append('send_email', 0);

    if(post.remove_image)
      formData.append('remove_image', 1);
    else
      formData.append('remove_image', 0);
    if (post.caption != undefined) {
      formData.append('caption', post.caption);
    }

    if (!post.category || !post.category.id) {
      return Promise.reject({ response: { data: { message: 'Category is required.' } } });
    }
    formData.append('category_id', post.category.id);
    // for (var i = 0; i < tagsNames.length; i++) {
    //     formData.append('tags[]', tagsNames[i]);
    // }

    // Editors use new_post_list (same as create/getPost); keep all_posts_create for admins who have it.
    const permissionKey = hasPermission('new_post_list')
      ? 'new_post_list'
      : (hasPermission('all_posts_create') ? 'all_posts_create' : null);

    if (!permissionKey) {
      return Promise.reject({ response: { data: { message: 'You do not have permission to update posts.' } } });
    }

    const response = await axios.post(
      '/admin/posts/' + post.slug + '?product_id=' + localStorage.getItem('product'),
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Permission': permissionKey
        }
      }
    );
    return response.data.post.slug;
  },

  // =========================================================================

  deletePost({commit}, post) {
    if(hasPermission('all_posts_delete')){
      const permission = {
        headers: {
          'X-Permission': 'all_posts_delete'
        }
      };
      return axios.post('/admin/posts/' + post.slug +'?product_id=' + localStorage.getItem('product'), {
        '_method': 'DELETE'
      },permission)
          .then((response) => {
            commit('DELETE_POSTS', post);
            return response.data.message;
          });
    }
  },

  // =========================================================================

  publishing({commit}, payload) {
    if(hasPermission('all_posts_list')){
      const permission = {
        headers: {
          'X-Permission': 'all_posts_list'
        }
      };
      return axios.post('/admin/posts/' + payload.post.slug + '/publishing?action=' + payload.action  +'&product_id=' + localStorage.getItem('product'),permission)
          .then((response) => {
            switch (payload.action) {
              case 'publish':
                payload.post.published = 1;
                payload.post.published_at = 'Just now';
                break;
              case 'unpublish':
                payload.post.published = 0;
                payload.post.published_at = '';
                break;
            }

            commit('SET_POST', payload.post);
            return response;
          });
    }

  },

  // =========================================================================

  assignTags({commit}, post) {
    let tagsNames = post.tags.map((tag) => {
      return tag.name;
    });

    let formData = new FormData();
    for (var i = 0; i < tagsNames.length; i++) {
        formData.append('tags[]', tagsNames[i]);
    }
    if(hasPermission('all_posts_list')){
      const permission = {
        headers: {
          'X-Permission': 'all_posts_list'
        }
      };
      return axios.post('/admin/posts/' + post.slug + '/assign-tags', formData,permission)
          .then((response) => {
            commit('SET_POST', response.data.post);
          });
    }

  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
